export const termInChinese = new Map();

termInChinese
  /******************************************
    。獲利分析圖 > 每股現流分析
    。選股
  ******************************************/
  .set("net_value_per_share", "每股淨值")

  /******************************************
    。獲利分析圖 > 每股現流分析
  ******************************************/
  .set("cash_dividends_paids_CFF_per_share", "支付現金股利-CFF")
  .set(
    "purchases_of_property_plant_equipment_include_prepaid_CFI_per_share",
    "購置不動產廠房設備(含預付)-CFI"
  )
  .set(
    "sum_of_cash_dividends_and_purchases_of_property_plant_equipment",
    "支付現金股利與購置設備"
  )
  .set("cash_flow_during_this_period_per_share", "本期產生現金流量")
  .set("net_worth_should_grow", "淨值應增長")

  /******************************************
    。選股
  ******************************************/
  .set("expected_rate_of_return", "預期投報")
  .set("stock_symbol", "股票代號")
  .set("company_name", "公司名稱")
  .set("level", "等級")
  .set("go_public", "狀態")
  .set("market_capital", "市值")
  .set("closing_price", "昨收")
  .set("net_value_ratio", "淨值比")
  .set("expected_reasonable_value", "預估每股合理價值")
  .set("consider_fund_reinvestment", "預估每股合理價值-考慮資金再投資")
  .set("discount_ratio", "折價比")
  .set("EBPR", "EBPR")
  .set("sum_of_EBIDTA", "近四季每股EBIDTA")
  .set("EPS_of_recently_four_seasons", "近四季每股EPS") //損益表-季表叫「近 4 季每股盈餘-完全稀釋-EPS」
  .set("EPS_price_earnings_ratio", "本益比")

  /******************************************
    。資產負債表
  ******************************************/
  .set("balance_sheets", "資產負債表")
  .set("cash_and_cash_equivalents", "現金及約當現金")
  .set(
    "short_term_investment_financial_assets_current",
    "短期投資金融資產－流動"
  )
  .set("accounts_and_bills_receivable", "應收帳款及票據")
  .set("other_receivables", "其他應收款")
  .set("loan_to_other_S_T", "短期借支")
  .set("inventories", "存貨")
  .set("prepaid_expenses_and_repayments", "預付費用及預付款")
  .set("other_current_assets", "其他流動資產")
  .set("current_assets", "流動資產")
  .set("long_term_investments", "長期投資")
  .set("property_plant_and_equipment", "不動產廠房及設備")
  .set("total_goodwill_and_intangible_assets", "商譽及無形資產合計")
  .set("total_intangible_assets", "遞延資產合計")
  .set("other_non_current_assets", "其他非流動資產")
  .set("non_current_assets", "非流動資產")
  .set("total_assets", "資產總額")
  .set("short_term_debt", "短期借款")
  .set("commercial_paper_payable_acceptance_bill", "應付商業本票 ∕ 承兌匯票")
  .set("short_term_financial_liability_current", "短期金融負債－流動")
  .set("accounts_and_bills_payable", "應付帳款及票據")
  .set("other_payables", "其他應付款")
  .set("current_tax_liabilities", "當期所得稅負債")
  .set("other_financial_liabilities_current", "其他金融負債－流動")
  .set("current_lease_liabilities", "租賃負債─流動")
  .set("long_term_liabilities_due_within_one_year", "一年內到期長期負債")
  .set("other_current_liabilities", "其他流動負債")
  .set("current_liabilities", "流動負債")
  .set("financial_liabilities_non_current", "金融負債－非流動")
  .set("corporate_bond", "公司債")
  .set("bank_loan_non_current", "銀行借款－非流動")
  .set("other_long_term_debt_payable_non_current", "其他長期借款－非流動")
  .set("total_other_L_T_liab", "其他負債及準備")
  .set("non_current_liabilities", "非流動負債")
  .set("total_liabilities", "負債總額")
  .set("share_capital", "股本")
  .set("total_capital_reserve", "資本公積合計")
  .set("retained_earnings", "保留盈餘")
  .set("other_equity", "其他權益")
  .set("treasury_stock", "庫藏股票帳面值")
  .set("total_equity", "股東權益總額")
  .set("total_liabilities_and_stockholders_equity", "負債及股東權益總額")
  .set("total_capital_investment_IC", "投資資本總額－IC")
  .set(
    "attributable_to_parent_company_shareholders_equity_total",
    "母公司股東權益合計"
  )

  /******************************************
    。綜合損益表
  ******************************************/
  .set("income_statements", "綜合損益表")
  .set("net_operating_revenue", "營業收入淨額")
  .set("cost_of_goods_sold", "營業成本")
  .set("realized_gross_profit", "已實現銷貨毛利")
  .set("operating_expenses", "營業費用")
  .set("other_gains_and_losses", "其他收益及費損淨額")
  .set("operating_income", "營業利益")
  .set("total_non_operating_revenue_and_expense", "營業外收入及支出")
  .set("income_before_tax", "稅前淨利")
  .set("income_tax_expense", "所得稅費用")
  .set("gains_and_losses_from_continuing_operations", "繼續營業單位損益")
  .set("consolidated_net_income", "合併總損益")
  .set("other_comprehensive_income_OCI", "其他綜合損益－OCI")
  .set("total_comprehensive_income", "本期綜合損益總額")
  .set("net_income_to_stockholders_company", "歸屬母公司淨利（損）")
  .set("comprehensive_income_to_stockholders_company", "綜合損益歸屬母公司")
  .set("earnings_before_interest_and_tax", "稅前息前淨利")
  .set("EBIDTA", "稅前息前折舊前淨利－EBIDTA")
  .set("EPS", "每股盈餘－完全稀釋－EPS")
  .set("per_share_EPS", "EPS")

  /******************************************
    。現金流量表
  ******************************************/
  .set("cash_flow_statements", "現金流量表")
  .set("profit_before_tax_CFO", "稅前淨利－CFO")
  .set("depreciation_CFO", "折舊－CFO")
  .set("amortization_CFO", "攤提－CFO")
  .set("decrease_increase_in_accounts_receivable_CFO", "應收帳款(增加)減少-CFO")
  .set("decrease_increase_in_inventories_CFO", "存貨(增加)減少-CFO")
  .set("increase_decrease_in_account_payable_CTO", "應付帳款增加(減少)-CTO")
  .set("cash_flows_from_operations", "來自營運之現金流量")
  .set(
    "purchases_of_property_plant_equipment_include_prepaid_CFI",
    "購置不動產廠房設備(含預付)-CFI"
  )
  .set(
    "disposals_of_property_plant_equipment_include_prepaid_CFI",
    "處分不動產廠房設備(含預付)-CFI"
  )
  .set("cash_flow_from_investment_activities", "投資活動之現金流量")
  .set("cash_dividends_paids_CFF", "支付現金股利-CFF")
  .set("cash_flow_from_fundraising", "籌資活動之現金流量")
  .set("cash_flow_during_this_period", "本期產生現金流量")

  /******************************************
    。財務比例分析
  ******************************************/
  .set("liquidities", "償債能力表")
  .set("return_on_investments", "獲利能力表")
  .set("per_share_ratios", "每股比例表")
  .set("operating_performances", "經營能力表")

  /******************************************
    。財務比例分析 > 獲利能力表
  ******************************************/
  .set("gross_profit_ratio", "毛利率")
  .set("operating_expense_ratio", "營業費用率")
  .set("net_profit_margin_ratio", "淨利率")
  .set("ROA", "ROA")
  .set("ROE", "ROE")
  .set("ROIC", "ROIC")
  .set("EBOA", "EBOA")
  .set("EBOE", "EBOE")
  .set("EBOIC", "EBOIC")

  /******************************************
    。財務比例分析 > 每股比例表
  ******************************************/
  .set("EBIDTA_per_share", "每股EBIDTA")
  .set("cash_reinvestment_ratio", "現金再投資比例")
  .set("dividend_redistribution_ratio", "現金股利分配比例")

  /******************************************
    。財務比例分析 > 經營能力表
  ******************************************/
  .set("days_of_cash_receivable", "應收帳款收現天數")
  .set("days_of_sales", "銷貨天數")
  .set("days_of_accounts_payable_turnover", "應付帳款週轉天數")
  .set("days_of_operation_turnover", "營運週轉天數")
  .set("days_of_cash_turnover", "現金週轉天數");
